import { render, staticRenderFns } from "./search-head.vue?vue&type=template&id=45b10904&scoped=true"
import script from "./search-head.vue?vue&type=script&lang=js"
export * from "./search-head.vue?vue&type=script&lang=js"
import style0 from "./search-head.vue?vue&type=style&index=0&id=45b10904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b10904",
  null
  
)

export default component.exports